import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CaptchaTokenStore } from './captcha-token.store';

/**
 * Credential requests the API only accepts with a solved security check. Kept
 * in step with the API routes that carry the captcha guard.
 */
export const CAPTCHA_PROTECTED_PATHS: readonly string[] = [
  '/authentication/login',
  '/authentication/admin/login',
  '/authentication/register',
  '/authentication/register-organization',
  '/authentication/request-password-reset',
  '/authentication/reset-password',
];

/** Body field the API reads the Turnstile token from. */
export const CAPTCHA_TOKEN_FIELD = 'captchaToken';

const isProtected = (url: string): boolean => {
  const path = url.split('?')[0];
  return CAPTCHA_PROTECTED_PATHS.some((p) => path.endsWith(p));
};

/**
 * Adds the pending Turnstile token to the protected credential request it was
 * earned for. Forms keep calling the captcha component before they submit;
 * this is what carries the result to the API.
 */
export const captchaTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.method !== 'POST' ||
    !isProtected(req.url) ||
    !req.body ||
    typeof req.body !== 'object' ||
    Array.isArray(req.body)
  ) {
    return next(req);
  }
  const token = inject(CaptchaTokenStore).take();
  if (!token) {
    return next(req);
  }
  return next(
    req.clone({
      body: { ...(req.body as Record<string, unknown>), [CAPTCHA_TOKEN_FIELD]: token },
    }),
  );
};
